//TextField_IBM.tsx =================================================
import "../Util/Prototypes";

import * as Settings from "../Settings";
import * as Util from "../Util/Util";

import { Input, InputAdornment } from "@mui/material";
import { grey, red } from '@mui/material/colors';

import React from "react";

interface iProps {
   id?: string;
   uid?: string;      // To force refresh when a new parcel is selected or total land value is changed.
   ii?: number;       // Index into mobile home array.
   fieldCode: string; // "Residential", etc.
   orig: number;      // Last years reassessment value.
   value?: number;    // Next years reassessment value.
   valueAny?: string; // Next years reassessment value with comma formatting.
   valuePickup?: number;    // Next years pickup value.
   valuePickupAny?: string; // Next years pickup value with comma formatting.
   onChange?(fieldCode: string, value: number, ii?: number): any;
}

export function Render(props: iProps) {
   //Util.logMsg("Rendering TextField_IBM ID:" + props.id);

   //Set refresh method.
   const [valueAny, setValueAny] = React.useState(props.valueAny);
   const [valuePickupAny, setValuePickupAny] = React.useState(props.valuePickupAny);
   const [percent, setPercent] = React.useState("");

   //Component did mount.
   React.useEffect(() => {
      //Util.logMsg("TextField_IBM did mount");
   }, []);

   //Component did update.
   React.useEffect(() => {
      //Util.logMsg("TextField_IBM did update");
      setValueAny(props.valueAny);
      setValuePickupAny(props.valuePickupAny);
      calcPercent(props.orig, props.value);
   }, [props.uid]); //To force refresh when a new parcel is selected.

   //Value changed.
   function handleChange(event: any) {
      const inValue: string = event.target.value.replace(/,/g, "").trim();

      let newValue: number = Util.parseInteger(inValue);
      if (newValue > 999999999 || newValue < 0) {
         newValue = 0;
      }

      let newValueAny: string = Util.formatTextValue(newValue, "Comma");
      if (newValueAny === "0" && inValue !== "0") {
         newValueAny = "";
      }

      setValueAny(newValueAny);
      calcPercent(props.orig, newValue);

      if (typeof props.ii === "undefined") {
         props.onChange(props.fieldCode, newValue);
      } else {
         props.onChange(props.fieldCode, newValue, props.ii);
      }
   }

   //Picup value changed.
   function handleChangePickup(event: any) {
      const inValue: string = event.target.value.replace(/,/g, "").trim();

      let newValue: number = Util.parseInteger(inValue);
      if (newValue > 999999999 || newValue < 0) {
         newValue = 0;
      }

      let newValueAny: string = Util.formatTextValue(newValue, "Comma");
      if (newValueAny === "0" && inValue !== "0") {
         newValueAny = "";
      }

      setValuePickupAny(newValueAny);
      props.onChange(props.fieldCode + " Pickup", newValue);
   }

   //Calculate percent change.
   function calcPercent(origValue, newValue): void {
      let newPercent: string = "";
      if (origValue > 0 && origValue !== newValue) {
         newPercent = Util.round(((newValue - origValue) / origValue) * 100, 2).toString() + " %";

      } else if (origValue === 0 && newValue > 0) {
         newPercent = "New";
      }
      setPercent(newPercent);
   }

   //Get string value.
   function getStringValue(inValue: any): string {
      let outValue: string = Util.formatTextValue(inValue, "Comma");
      if (outValue === "0") {
         outValue = "";
      }
      return outValue;
   }

   //Render components.
   const styles: any = {
      bodyCellLeft: { padding: 3, textAlign: 'left', backgroundColor: Settings.leftPanelLabelColor, color: 'black', fontSize: Settings.detailsFontSize, borderTop: '1px solid silver' },
      bodyCellInput: { width: 100, padding: 3, paddingLeft: 5, paddingBottom: 1, textAlign: 'left', color: 'black', fontSize: Settings.detailsFontSize, borderTop: '1px solid silver' },
      bodyCellLast: { padding: 3, paddingRight: 7, textAlign: 'right', backgroundColor: Settings.leftPanelLabelColor, color: grey[500], fontSize: Settings.detailsFontSize, borderTop: '1px solid silver' },
      bodyCellChange: { width: 80, padding: 3, paddingRight: 7, textAlign: 'center', backgroundColor: Settings.leftPanelLabelColor, color: grey[500], fontSize: Settings.detailsFontSize, borderTop: '1px solid silver' },
      bodyCellChangeRed: { width: 80, padding: 3, paddingRight: 7, textAlign: 'center', backgroundColor: red[100], fontSize: Settings.detailsFontSize, borderTop: '1px solid silver' },
   };

   const origAny = getStringValue(props.orig);

   //Percent change color.
   const percentFloat: number = Util.parseFlt(percent);
   let changeColor: any = styles.bodyCellChange;
   if (percentFloat > 20 || percentFloat < -20) {
      changeColor = styles.bodyCellChangeRed;
   }

   //Pickups.
   if (typeof props.valuePickup !== "undefined") {
      return (
         <tr>
            <td style={styles.bodyCellLeft}>{props.fieldCode}</td>
            <td style={styles.bodyCellLast}>{origAny}</td>
            <td style={styles.bodyCellInput}>
               <Input
                  id={props.id}
                  value={valueAny}
                  onChange={handleChange}
                  margin="dense"
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
               />
            </td>
            <td style={changeColor}>{percent}</td>
            <td style={styles.bodyCellInput}>
               <Input
                  id={props.id + "Pickup"}
                  value={valuePickupAny}
                  onChange={handleChangePickup}
                  margin="dense"
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
               />
            </td>
         </tr>
      ); //end return.

      //Other input elements.
   } else {
      return (
         <tr>
            <td style={styles.bodyCellLeft}>{props.fieldCode}</td>
            <td style={styles.bodyCellLast}>{origAny}</td>
            <td style={styles.bodyCellInput}>
               <Input
                  id={props.id}
                  value={valueAny}
                  onChange={handleChange}
                  margin="dense"
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
               />
            </td>
            <td style={changeColor}>{percent}</td>

         </tr>
      ); //end return. <td style={styles.bodyCellChange}></td>
   }

} //end function.
